import { useEffect, useState } from 'react';
import favicon from '../../assets/images/favicon.png';
import orange_and_black_new from '../../assets/images/orange-and-black-new.png';
import { API_STATUS } from '../../constants';
import { GetActiveUser } from '../../apis/user/get_active_user';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { reloadState } from '../../redux/GlobalSlice';
import CreatePost from '../posts/create_post_back';
import { GetUnreadMsgCount } from '../../apis/message/get_unread_mcount';
import NotificationList from './notification_list';
import { GetNoteCountApi } from '../../apis/notification/get_note_count';
import { NoteReadApi } from '../../apis/notification/note_read_api';
import Search from './search';
import { ShareProfileApi } from '../../apis/user/share_profile_api';
import { DeleteUserApi } from '../../apis/user/delete_user_api';

export default function HeaderMenu() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const globalState = useSelector(state => state.globalstate);

    const [activeUser, setActiveUser] = useState('');

    const [umApi, setUmApi] = useState(API_STATUS);
    const [notecApi, setNotecApi] = useState(API_STATUS);
    const [unreadMsgCount, setunreadMsgCount] = useState('0');
    const [mncount, setMncount] = useState('0');
    const [noteRead, setNoteRead] = useState(API_STATUS);
    const [shareApi, setShareApi] = useState(API_STATUS);
    const [delApi, setDelApi] = useState(API_STATUS);
    const [shareStatus, setShareStatus] = useState(1);

    const [kyc, setKyc] = useState(0);
    const [declaration, setDeclaration] = useState(0);
    const [liveness, setLiveness] = useState(0);

    useEffect(() => {
        if (globalState.refresh_login) {
            const loginData = localStorage.getItem('LOGIN_DATA');
            const userData = JSON.parse(loginData);
            
            setDeclaration(localStorage.getItem('DECLARATION'));
            setLiveness(localStorage.getItem('LIVENESS'));
            setKyc(localStorage.getItem('KYC'));

            setActiveUser(userData);
            dispatch(reloadState({ 'refresh_login': false }));

            if (userData['userPic'] === '') {
                navigate('/update_profile_pic', { state: { userData: userData } });
            }

        }
    }, [globalState]);

    useEffect(() => {
        setDeclaration(localStorage.getItem('DECLARATION'));
        setLiveness(localStorage.getItem('LIVENESS'));
        setKyc(localStorage.getItem('KYC'));

        const loginData = localStorage.getItem('LOGIN_DATA');
        if (loginData !== null) {
            const userData = JSON.parse(loginData);
            if (userData['status'] === 2) {
                navigate('/account_status');
            }
            setActiveUser(userData);
            setShareStatus(userData['shareProfile']);
        }
    }, [])

    const ulogout = () => {
        sessionStorage.removeItem('LOGIN_TOKEN');
        sessionStorage.removeItem('LOGIN_DATA');

        localStorage.removeItem('LOGIN_TOKEN');
        localStorage.removeItem('LOGIN_DATA');
        navigate('/login');
    }

    useEffect(() => {
        if (!umApi.isError && !umApi.isLoader && umApi.data != null) {
            let res = umApi.data;
            if (res['status'] === 1) {
                setunreadMsgCount(res['data'].toString());
            }
        }
    }, [umApi]);

    useEffect(() => {
        if (!shareApi.isError && !shareApi.isLoader && shareApi.data != null) {
            const res = shareApi.data;
            sessionStorage.setItem('LOGIN_DATA', JSON.stringify(res.data));
        }
    }, [shareApi]);

    useEffect(() => {
        if (!delApi.isError && !delApi.isLoader && delApi.data != null) {
            sessionStorage.removeItem('LOGIN_TOKEN');
            sessionStorage.removeItem('LOGIN_DATA');
            navigate('/login');
        }
    }, [delApi]);

    useEffect(() => {
        GetUnreadMsgCount(setUmApi);
        GetNoteCountApi(setNotecApi);
    }, []);

    useEffect(() => {
        if (!notecApi.isError && !notecApi.isLoader && notecApi.data != null) {
            let res = notecApi.data;
            if (res['status'] === 1) {
                setMncount(res['data'].toString());
            }
        }
    }, [notecApi]);

    const navProfilePic = () => {
        const loginData = sessionStorage.getItem('LOGIN_DATA');
        const userData = JSON.parse(loginData);

        navigate('/update_profile_pic', { state: { userData: activeUser } });

    }

    const navEditProfile = () => {
        navigate('/edit_profile', { state: { userData: activeUser } });
    }

    const password_reset = () => {
        navigate('/password_reset');
    }

    const shareProfile = () => {
        if (shareStatus === 1) {
            setShareStatus(0);
            ShareProfileApi({ 'status': 0 }, setShareApi);
        } else {
            setShareStatus(1);
            ShareProfileApi({ 'status': 1 }, setShareApi);
        }
    }

    return <div id="sidebar" className="fixed top-0 left-0 z-40 max-md:top-auto max-md:bottom-0">

        <div id="sidebar__inner" className="flex sside md:flex-col justify-between md:h-screen md:p-2 p-1 transition-all duration-500 bg-white shadow dark:bg-dark2 2xl:w-72 xl:w-60 max-xl:w-[73px] max-md:w-screen max-md:border-t max-md:dark:border-slate-700">

            <div className="flex h-20 px-2 max-md:fixed max-md:top-0 max-md:w-full max-md:bg-white/80 max-md:left-0 max-md:px-4 max-md:h-14 max-md:shadow-sm max-md:dark:bg-slate-900/80 backdrop-blur-xl">
                <a href="/" id="logo" className="flex items-center gap-3">

                    <img id="logo__icon" src={favicon} alt="" className="md:w-8 hidden text-2xl max-xl:!block max-md:!hidden shrink-0 uk-animation-scale-up" />

                    <img id="logo__text" src={orange_and_black_new} alt="" className="w-full h-12 ml-1 max-xl:hidden max-md:block dark:!hidden" />
                    <img id="logo__text" src={orange_and_black_new} alt="" className="w-full h-12 ml-1 !hidden max-xl:!hidden max-md:block dark:max-md:!block dark:!block" />

                </a>
            </div>

            {
                activeUser !== "" && activeUser !== null && kyc == 1 && declaration == 1 &&


                <nav className="flex-1 max-md:flex max-md:justify-around md:space-y-2">

                    <a href="/" className="active">
                        <svg id="icon__outline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
                        </svg>
                        <svg id="icon__solid" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="hidden">
                            <path fill-rule="evenodd" d="M9.293 2.293a1 1 0 011.414 0l7 7A1 1 0 0117 11h-1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-6H3a1 1 0 01-.707-1.707l7-7z" clip-rule="evenodd" />
                        </svg>
                        <span className="max-xl:hidden"> Home </span>
                    </a>

                    <a href="">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" >
                            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                        </svg>
                        <span className="max-xl:hidden"> Search </span>
                    </a>
                    {
                        <Search />
                    }

                    <Link to={'/posts'}>
                        <svg id="icon__outline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 7.5l16.5-4.125M12 6.75c-2.708 0-5.363.224-7.948.655C2.999 7.58 2.25 8.507 2.25 9.574v9.176A2.25 2.25 0 004.5 21h15a2.25 2.25 0 002.25-2.25V9.574c0-1.067-.75-1.994-1.802-2.169A48.329 48.329 0 0012 6.75zm-1.683 6.443l-.005.005-.006-.005.006-.005.005.005zm-.005 2.127l-.005-.006.005-.005.005.005-.005.005zm-2.116-.006l-.005.006-.006-.006.005-.005.006.005zm-.005-2.116l-.006-.005.006-.005.005.005-.005.005zM9.255 10.5v.008h-.008V10.5h.008zm3.249 1.88l-.007.004-.003-.007.006-.003.004.006zm-1.38 5.126l-.003-.006.006-.004.004.007-.006.003zm.007-6.501l-.003.006-.007-.003.004-.007.006.004zm1.37 5.129l-.007-.004.004-.006.006.003-.004.007zm.504-1.877h-.008v-.007h.008v.007zM9.255 18v.008h-.008V18h.008zm-3.246-1.87l-.007.004L6 16.127l.006-.003.004.006zm1.366-5.119l-.004-.006.006-.004.004.007-.006.003zM7.38 17.5l-.003.006-.007-.003.004-.007.006.004zm-1.376-5.116L6 12.38l.003-.007.007.004-.004.007zm-.5 1.873h-.008v-.007h.008v.007zM17.25 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zm0 4.5a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                        </svg>
                        <svg id="icon__solid" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="hidden">
                            <path fill-rule="evenodd" d="M20.432 4.103a.75.75 0 00-.364-1.455L4.128 6.632l-.2.033C2.498 6.904 1.5 8.158 1.5 9.575v9.175a3 3 0 003 3h15a3 3 0 003-3V9.574c0-1.416-.997-2.67-2.429-2.909a49.016 49.016 0 00-7.255-.658l7.616-1.904zm-9.585 8.56a.75.75 0 010 1.06l-.005.006a.75.75 0 01-1.06 0l-.006-.005a.75.75 0 010-1.061l.005-.005a.75.75 0 011.06 0l.006.005zM9.781 15.85a.75.75 0 001.061 0l.005-.005a.75.75 0 000-1.061l-.005-.005a.75.75 0 00-1.06 0l-.006.005a.75.75 0 000 1.06l.005.006zm-1.055-1.066a.75.75 0 010 1.06l-.005.006a.75.75 0 01-1.061 0l-.005-.005a.75.75 0 010-1.06l.005-.006a.75.75 0 011.06 0l.006.005zM7.66 13.73a.75.75 0 001.061 0l.005-.006a.75.75 0 000-1.06l-.005-.005a.75.75 0 00-1.06 0l-.006.005a.75.75 0 000 1.06l.005.006zM9.255 9.75a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75h-.008a.75.75 0 01-.75-.75V10.5a.75.75 0 01.75-.75h.008zm3.624 3.28a.75.75 0 00.275-1.025L13.15 12a.75.75 0 00-1.025-.275l-.006.004a.75.75 0 00-.275 1.024l.004.007a.75.75 0 001.024.274l.007-.003zm-1.38 5.126a.75.75 0 01-1.024-.274l-.004-.007a.75.75 0 01.275-1.024l.006-.004a.75.75 0 011.025.274l.004.007a.75.75 0 01-.275 1.024l-.006.004zm.282-6.776a.75.75 0 00-.274-1.025l-.007-.003a.75.75 0 00-1.024.274l-.004.007a.75.75 0 00.274 1.024l.007.004a.75.75 0 001.024-.274l.004-.007zm1.369 5.129a.75.75 0 01-1.025.274l-.006-.003a.75.75 0 01-.275-1.025l.004-.006a.75.75 0 011.025-.275l.006.004a.75.75 0 01.275 1.024l-.004.007zm-.145-1.502a.75.75 0 00.75-.75v-.007a.75.75 0 00-.75-.75h-.008a.75.75 0 00-.75.75v.008c0 .414.336.75.75.75h.008zm-3.75 2.243a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75h-.008a.75.75 0 01-.75-.75V18a.75.75 0 01.75-.75h.008zm-2.871-.47a.75.75 0 00.274-1.025l-.003-.006a.75.75 0 00-1.025-.275l-.006.004a.75.75 0 00-.275 1.025l.004.006a.75.75 0 001.024.274l.007-.003zm1.366-5.12a.75.75 0 01-1.025-.274l-.004-.006a.75.75 0 01.275-1.025l.006-.003a.75.75 0 011.025.274l.004.007a.75.75 0 01-.275 1.024l-.006.004zm.281 6.215a.75.75 0 00-.275-1.024l-.006-.004a.75.75 0 00-1.025.274l-.003.007a.75.75 0 00.274 1.024l.007.004a.75.75 0 001.024-.274l.004-.007zM6.655 12.76a.75.75 0 01-1.025.274l-.006-.003a.75.75 0 01-.275-1.025L5.353 12a.75.75 0 011.025-.275l.006.004a.75.75 0 01.275 1.024l-.004.007zm-1.15 2.248a.75.75 0 00.75-.75v-.007a.75.75 0 00-.75-.75h-.008a.75.75 0 00-.75.75v.008c0 .414.336.75.75.75h.008zM17.25 10.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm1.5 6a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z" clip-rule="evenodd" />
                        </svg>
                        <span className="max-xl:hidden"> Posts </span>
                    </Link>
                    {
                        activeUser['userType'] === 0 &&
                        <Link to={'/create_post'}>
                            <button uk-toggle="target: #create-post" className="flex items-center gap-3 w-full" aria-expanded="false">
                                <svg id="icon__outline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                </svg>
                                <svg id="icon__solid" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="hidden">
                                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-11.25a.75.75 0 00-1.5 0v2.5h-2.5a.75.75 0 000 1.5h2.5v2.5a.75.75 0 001.5 0v-2.5h2.5a.75.75 0 000-1.5h-2.5v-2.5z" clip-rule="evenodd"></path>
                                </svg>
                                <span className="max-xl:hidden"> Create Post </span></button>
                        </Link>
                    }
                    {
                        activeUser['userType'] === 1 &&
                        <Link to={'/create_event'} className="max-md:!hidden">
                            <svg id="icon__outline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 6.878V6a2.25 2.25 0 012.25-2.25h7.5A2.25 2.25 0 0118 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 004.5 9v.878m13.5-3A2.25 2.25 0 0119.5 9v.878m0 0a2.246 2.246 0 00-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0121 12v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6c0-.98.626-1.813 1.5-2.122" />
                            </svg>
                            <svg id="icon__solid" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="hidden">
                                <path d="M5.566 4.657A4.505 4.505 0 016.75 4.5h10.5c.41 0 .806.055 1.183.157A3 3 0 0015.75 3h-7.5a3 3 0 00-2.684 1.657zM2.25 12a3 3 0 013-3h13.5a3 3 0 013 3v6a3 3 0 01-3 3H5.25a3 3 0 01-3-3v-6zM5.25 7.5c-.41 0-.806.055-1.184.157A3 3 0 016.75 6h10.5a3 3 0 012.683 1.657A4.505 4.505 0 0018.75 7.5H5.25z" />
                            </svg>
                            <span className="max-xl:hidden"> Create Event </span>
                        </Link>
                    }

                    <Link to={'/message_users'} className="max-md:!fixed max-md:top-2 max-md:right-2">
                        <svg id="icon__outline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                        </svg>
                        <svg id="icon__solid" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="hidden">
                            <path fill-rule="evenodd" d="M4.848 2.771A49.144 49.144 0 0112 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97a48.901 48.901 0 01-3.476.383.39.39 0 00-.297.17l-2.755 4.133a.75.75 0 01-1.248 0l-2.755-4.133a.39.39 0 00-.297-.17 48.9 48.9 0 01-3.476-.384c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97zM6.75 8.25a.75.75 0 01.75-.75h9a.75.75 0 010 1.5h-9a.75.75 0 01-.75-.75zm.75 2.25a.75.75 0 000 1.5H12a.75.75 0 000-1.5H7.5z" clip-rule="evenodd"></path>
                        </svg>
                        <span className="max-xl:hidden"> Messages </span>
                        {
                            unreadMsgCount !== '0' &&
                            <div className="w-4 h-4 bg-red-600 rounded-full text-xs text-white absolute left-7 top-2.5" style={{ textAlign: "center" }}>{unreadMsgCount}</div>
                        }
                    </Link>
                    <Link onClick={() => {
                        NoteReadApi(setNoteRead);
                        setMncount(0);
                    }} className="max-md:!fixed max-md:top-2 max-md:right-14 relative">
                        <svg id="icon__outline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
                        </svg>
                        <svg id="icon__solid" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="hidden">
                            <path d="M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z" />
                        </svg>
                        <span className="max-xl:hidden"> Notifications </span>
                        {
                            mncount > 0 &&
                            <div className="w-4 h-4 bg-red-600 rounded-full text-xs text-white absolute left-7 top-2.5" style={{ textAlign: "center" }}>{mncount}</div>
                        }
                    </Link>
                    <NotificationList setMncount={setMncount} />



                    <a href={'/profile/' + activeUser['token']} >

                        <svg id="icon__outline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <svg id="icon__solid" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="hidden">
                            <path fill-rule="evenodd" d="M18.685 19.097A9.723 9.723 0 0021.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 003.065 7.097A9.716 9.716 0 0012 21.75a9.716 9.716 0 006.685-2.653zm-12.54-1.285A7.486 7.486 0 0112 15a7.486 7.486 0 015.855 2.812A8.224 8.224 0 0112 20.25a8.224 8.224 0 01-5.855-2.438zM15.75 9a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" clip-rule="evenodd" />
                        </svg>
                        <span className="max-xl:hidden"> Profile </span>
                    </a>

                </nav>
            }
            {
                activeUser !== "" && activeUser !== null && kyc == 1 && declaration == 1 &&

                <div>
                    <a href={'/profile/' + activeUser['token']} id="profile-link" className="flex items-center gap-3 p-3 group">
                        <img src={activeUser['userPic']} alt="" className="rounded-full md:w-7 md:h-7 w-5 h-5 shrink-0" />
                        <span className="font-semibold text-sm max-xl:hidden">  {activeUser['firstName']} {activeUser['u_lastName']} </span>
                        <ion-icon name="chevron-forward-outline" className="text-xl ml-auto duration-200 group-aria-expanded:-rotate-90 max-xl:hidden"></ion-icon>
                    </a>
                    <div className="bg-white sm:w-64 2xl:w-[calc(100%-16px)] w-full shadow-lg border rounded-xl overflow-hidden max-md:!top-auto max-md:bottom-16 border2 dark:bg-dark2 hidden" uk-drop="animation:uk-animation-slide-bottom-medium ;animate-out: true">

                        <div className="w-full h-1.5 bg-gradient-to-r to-purple-500 via-red-500 from-pink-500"></div>

                        <div className="p-4 text-xs font-medium">
                            <a href={'/profile/' + activeUser['token']}>
                                {/* <img src={activeUser['userPic']} className="w-8 h-8 rounded-full" alt="" /> */}
                                <div className="mt-2 space-y-0.5">
                                    <div className="text-base font-semibold"> {activeUser['firstName']} {activeUser['u_lastName']} </div>
                                    <div className="text-gray-400 dark:text-white/80"> {activeUser['username']} </div>
                                </div>
                            </a>

                        </div>
                        <hr className="opacity-60" />
                        <ul className="text-sm font-semibold p-2">
                            <li> <Link onClick={navEditProfile} className="flex gap-3 rounded-md p-2 hover:bg-secondery"> <i class="fa fa-pencil mt-1" aria-hidden="true"></i>Edit Profile  </Link></li>
                            <li> <Link onClick={navProfilePic} className="flex gap-3 rounded-md p-2 hover:bg-secondery"> <i class="fa fa-crosshairs mt-1" aria-hidden="true"></i>Profile Pic  </Link></li>
                        </ul>
                        {/* <div className="text-sm px-3">Settings & Security</div> */}
                        <ul className="text-sm font-semibold" style={{ paddingLeft: '0.5rem', paddingRight: '0.5rem' }}>
                            <li> <Link onClick={password_reset} className="flex gap-3 rounded-md p-2 hover:bg-secondery"> <i class="fa fa-sliders mt-1" aria-hidden="true"></i>Settings & Security </Link></li>
                            <li>
                                <Link onClick={shareProfile} className="flex gap-3 rounded-md p-2 hover:bg-secondery">
                                    {
                                        shareStatus === 1 ? <i class="fa fa-toggle-on mt-1 text-blue-600" aria-hidden="true"></i> : <i class="fa fa-toggle-off mt-1" aria-hidden="true"></i>
                                    }
                                    Share Profile
                                </Link>
                            </li>
                            <li> <Link onClick={() => {
                                DeleteUserApi(setDelApi);


                            }} className="flex gap-3 rounded-md p-2 hover:bg-secondery"> <i class="fa fa-trash" aria-hidden="true"></i>Delete  Profile  </Link></li>

                        </ul>

                        <ul className="text-sm font-semibold" style={{ paddingLeft: '0.5rem', paddingRight: '0.5rem' }}>
                            <li> <Link
                                to={'/saved_posts'}
                                className="flex gap-3 rounded-md p-2 hover:bg-secondery"> <ion-icon name="settings-outline" className="text-lg"></ion-icon> Saved Posts</Link></li>
                            {
                                activeUser['userType'] === 0 &&
                                <li> <Link
                                    to={'/archived_posts'}
                                    className="flex gap-3 rounded-md p-2 hover:bg-secondery"> <ion-icon name="settings-outline" className="text-lg"></ion-icon> Archived Posts</Link></li>
                            }
                            <li> <Link
                                to={'/saved_events'}
                                className="flex gap-3 rounded-md p-2 hover:bg-secondery"> <ion-icon name="settings-outline" className="text-lg"></ion-icon> Saved Events</Link></li>
                            {/* {
                                activeUser['userType'] === 0 &&
                                <li> <Link
                                    to={'/storage'}
                                    className="flex gap-3 rounded-md p-2 hover:bg-secondery"> <ion-icon name="settings-outline" className="text-lg"></ion-icon> Storage</Link></li>
                            } */}
                            <li> <a href="https://filmwings.com/site/policy" className="flex gap-3 rounded-md p-2 hover:bg-secondery"> <ion-icon name="settings-outline" className="text-lg"></ion-icon> Privacy Policy  </a></li>
                            <li> <a href="https://filmwings.com/site/policy" className="flex gap-3 rounded-md p-2 hover:bg-secondery"> <ion-icon name="settings-outline" className="text-lg"></ion-icon> User Terms  </a></li>
                            <li> <Link onClick={ulogout} className="flex gap-3 rounded-md p-2 hover:bg-secondery"> <ion-icon name="log-out-outline" className="text-lg"></ion-icon> Log Out</Link></li>
                        </ul>

                    </div>
                </div>
            }

        </div>


    </div>




}